import CONSIDERATIONS, { considerations } from 'enums/Considerations';
import EXPERTISE, { expertises } from 'enums/Expertise';
import FORMATIONS, { formations } from 'enums/Formation';
import FORMATION_PROJECT_MATCHES, {
  formationProjectMatches,
} from 'enums/FormationProjectMatches';
import FORMATION_STATES, { formationStates } from 'enums/FormationState';
import HOBBIES, { hobbies } from 'enums/Hobby';
import {
  MENTEE_PRIORITY_LEVELS,
  MENTOR_PRIORITY_LEVELS,
  priorityLevels,
} from 'enums/PriorityLevels';
import STUDY_LEVELS, { studyLevels } from 'enums/StudyLevels';
import VOLUNTEER_STATES, { volunteerStates } from 'enums/VolunteerState';

export const getJobSearchColumn = (version: 'mentee' | 'mentor') => {
  return {
    columnName: 'jobSearch',
    columnTitle: "Recherche d'emploi",
    tags: priorityLevels.map((priorityLevel) => {
      const value =
        version === 'mentee'
          ? MENTEE_PRIORITY_LEVELS[priorityLevel]
          : MENTOR_PRIORITY_LEVELS[priorityLevel];
      return {
        name: priorityLevel,
        label: `(Emploi) ${value}`,
        labelComponent: value,
      };
    }),
  } as const;
};

export const getCareerPlanColumn = (version: 'mentee' | 'mentor') => {
  return {
    columnName: 'careerPlan',
    columnTitle: 'Plan de carrière',
    tags: priorityLevels.map((priorityLevel) => {
      const value =
        version === 'mentee'
          ? MENTEE_PRIORITY_LEVELS[priorityLevel]
          : MENTOR_PRIORITY_LEVELS[priorityLevel];
      return {
        name: priorityLevel,
        label: `(Carrière) ${value}`,
        labelComponent: value,
      };
    }),
  } as const;
};
export const getStudiesColumn = (version: 'mentee' | 'mentor') => {
  return {
    columnName: 'studies',
    columnTitle: 'Études',
    tags: priorityLevels.map((priorityLevel) => {
      const value =
        version === 'mentee'
          ? MENTEE_PRIORITY_LEVELS[priorityLevel]
          : MENTOR_PRIORITY_LEVELS[priorityLevel];
      return {
        name: priorityLevel,
        label: `(Études) ${value}`,
        labelComponent: value,
      };
    }),
  } as const;
};

export const getEntrepreneurshipColumn = (version: 'mentee' | 'mentor') => {
  return {
    columnName: 'entrepreneurship',
    columnTitle: 'Entreprenariat',
    tags: priorityLevels.map((priorityLevel) => {
      const value =
        version === 'mentee'
          ? MENTEE_PRIORITY_LEVELS[priorityLevel]
          : MENTOR_PRIORITY_LEVELS[priorityLevel];
      return {
        name: priorityLevel,
        label: `(Entreprenariat) ${value}`,
        labelComponent: value,
      };
    }),
  } as const;
};

export const expertiseFieldsColumn = {
  columnName: 'expertiseFields',
  columnTitle: 'Champs de compétence',
  tags: expertises.map((expertise) => ({
    name: expertise,
    label: EXPERTISE[expertise],
  })),
} as const;

export const completedFormationColumn = {
  columnName: 'completedFormation',
  columnTitle: 'Formation effectuée',
  tags: formations.map((formation) => ({
    name: formation,
    label: `(Formation effectuée) ${FORMATIONS[formation]}`,
    labelComponent: FORMATIONS[formation],
  })),
} as const;

export const validatedDiplomaColumn = {
  columnName: 'validatedDiploma',
  columnTitle: 'Plus haut niveau de diplôme',
  tags: studyLevels.map((studyLevel) => ({
    name: studyLevel,
    label: `(Niveau de diplôme) ${STUDY_LEVELS[studyLevel]}`,
    labelComponent: STUDY_LEVELS[studyLevel],
  })),
} as const;

export const formationMatchingProjectColumn = {
  columnName: 'formationMatchingProject',
  columnTitle: 'Formation en accord avec le projet ?',
  tags: formationProjectMatches.map((match) => ({
    name: match,
    label: `(Formation en accord ?) ${FORMATION_PROJECT_MATCHES[match]}`,
    labelComponent: FORMATION_PROJECT_MATCHES[match],
  })),
} as const;

export const formationStateColumn = {
  columnName: 'formationState',
  columnTitle: 'État de la formation',
  tags: formationStates.map((formationState) => ({
    name: formationState,
    label: FORMATION_STATES[formationState],
  })),
} as const;

export const intendedFormationColumn = {
  columnName: 'intendedFormation',
  columnTitle: 'Formation correspondant au projet',
  tags: formations.map((formation) => ({
    name: formation,
    label: `(Formation correspondante) ${FORMATIONS[formation]}`,
    labelComponent: FORMATIONS[formation],
  })),
} as const;

export const intendedDiplomaColumn = {
  columnName: 'intendedDiploma',
  columnTitle: 'Niveau de diplôme visé',
  tags: studyLevels.map((studyLevel) => ({
    name: studyLevel,
    label: `(Diplôme visé) ${STUDY_LEVELS[studyLevel]}`,
    labelComponent: STUDY_LEVELS[studyLevel],
  })),
} as const;

export const considerationColumn = {
  columnName: 'consideration',
  columnTitle: 'Mode de vie',
  tags: considerations.map((consideration) => ({
    name: consideration,
    label: CONSIDERATIONS[consideration],
  })),
} as const;

export const hobbyColumn = {
  columnName: 'hobby',
  columnTitle: 'Passe temps',
  tags: hobbies.map((hobby) => ({
    name: hobby,
    label: HOBBIES[hobby],
  })),
} as const;

export const volunteerStateColumn = {
  columnName: 'volunteerState',
  columnTitle: 'État du service civique',
  tags: volunteerStates.map((volunteerState) => ({
    name: volunteerState,
    label: VOLUNTEER_STATES[volunteerState],
  })),
} as const;

export const formationsColumn = {
  columnName: 'formations',
  columnTitle: 'Formation effectuée',
  tags: formations.map((formation) => ({
    name: formation,
    label: FORMATIONS[formation],
  })),
} as const;

export const diplomaColumn = {
  columnName: 'diploma',
  columnTitle: 'Niveau de diplôme',
  tags: studyLevels.map((studyLevel) => ({
    name: studyLevel,
    label: STUDY_LEVELS[studyLevel],
  })),
} as const;

export const wantedMentorshipsColumn = {
  columnName: 'wantedMentorships',
  columnTitle: 'Mentorats souhaités',
  tags: [1, 2, 3, 4, 5].map((number) => ({
    name: number.toString(),
    label: `(Souhaités) ${number}`,
    labelComponent: number.toString(),
  })),
} as const;
